<template>
  <v-card class="mb-25 pingo-card">
    <div class="v-card-header border-bottom">
      <h5 class="mb-0">Configurações</h5>
    </div>

    <!-- Navigate -->
    <ul class="ps-0 mt-0">
      <li>
        <router-link to="/configuracoes/conta"> Conta </router-link>
      </li>
      <li>
        <router-link to="/configuracoes/enderecos"> Endereços </router-link>
      </li>
      <li>
        <router-link to="/configuracoes/politica-de-privacidade">
          Política de Privacidade
        </router-link>
      </li>
      <li>
        <router-link to="/configuracoes/termos-e-condicoes">
          Termos e Condições
        </router-link>
      </li>
    </ul>

    <!-- Form -->
    <form>
      <div class="mb-20">
        <h5 class="fw-semibold mb-8">Termos e Condições</h5>
        <p>Visualize aqui os termos e condições da plataforma.</p>
      </div>

      <span class="d-block fw-semibold mb-10"> Autenticação de dois fatores </span>

      <p>
        A autenticação de dois fatores é uma medida de segurança aprimorada. Uma vez
        habilitada, você precisará fornecer dois tipos de identificação ao fazer login.
        Autenticação via Google e SMS são suportados.
      </p>

      <span class="d-block mt-20 fw-semibold mb-10">Verificação Secundária</span>

      <p>
        A autenticação de dois fatores é uma medida de segurança aprimorada. Uma vez
        habilitada, você precisará fornecer dois tipos de identificação ao fazer login.
        Autenticação via Google e SMS são suportados.
      </p>

      <span class="d-block mt-20 fw-semibold mb-10">Códigos de Backup</span>

      <p>
        A autenticação de dois fatores é uma medida de segurança aprimorada. Uma vez
        habilitada, você precisará fornecer dois tipos de identificação ao fazer login.
        Autenticação via Google e SMS são suportados.
      </p>

      <span class="d-block mt-20 fw-semibold mb-10">
        Notificações de desktop, email, chat, compra
      </span>

      <p>
        A autenticação de dois fatores é uma medida de segurança aprimorada. Uma vez
        habilitada, você precisará fornecer dois tipos de identificação ao fazer login.
        Autenticação via Google e SMS são suportados.
      </p>
    </form>
  </v-card>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "SettingsTermsConditionsPage",
});
</script>

<style lang="scss" scoped>
button,
a {
  padding: 14px 35px !important;
  border-radius: 5px !important;

  &.gray {
    color: var(--blackColor);
  }
  font: {
    weight: 600 !important;
    size: 14px !important;
  }
}

ul {
  list-style-type: none;
  margin-bottom: 15px;

  li {
    display: inline-block;
    margin: {
      right: 15px;
      bottom: 15px;
    }
    a {
      color: var(--paragraphColor);
      background-color: #f4f4f4;
      display: inline-block;
      border-radius: 5px;
      padding: 10px 25px;
      font: {
        size: var(--fontSize);
        weight: 600;
      }
      &:hover,
      &.active {
        background-color: var(--heraBlueColor);
        color: var(--whiteColor);
      }
    }
    &:last-child {
      margin-right: 0;
    }
  }
}

@media only screen and (max-width: 767px) {
  ul {
    li {
      a {
        font-size: 14px;
      }
    }
  }
}
</style>
